// create by chatgpt and refactoring code
import React, { ReactNode, Fragment, Children } from 'react';

type IfProps = {
    condition: boolean | string | number | null | undefined;
    children: ReactNode;
};

type SimpleProps = {
    children: ReactNode;
};

// Then
function Then({ children }: SimpleProps) {
    return <>{children}</>;
}

// Else
function Else({ children }: SimpleProps) {
    return <>{children}</>;
}

// ElseIf
function ElseIf({ children }: IfProps) {
    return <>{children}</>;
}

// If
function If({ condition, children }: IfProps) {
    const childArray = Children.toArray(children);
    let hasRendered = false;

    const rendered = childArray.map((child: any, index: number) => {
        if (hasRendered) return null;

        if (child.type === Then && condition) {
            hasRendered = true;
            return <Fragment key={index}>{child.props.children}</Fragment>;
        }

        if (!condition && child.type === ElseIf && child.props.condition) {
            hasRendered = true;
            return <Fragment key={index}>{child.props.children}</Fragment>;
        }

        if (!condition && child.type === Else) {
            hasRendered = true;
            return <Fragment key={index}>{child.props.children}</Fragment>;
        }

        return null;
    });

    return <>{rendered}</>;
}

export { If, Then, ElseIf, Else };
